import { useEffect, useState } from 'react'

let isLoadingState = false
let listeners = []

const setLoaderState = (state) => {
    isLoadingState = state
    listeners.forEach(listener => listener(isLoadingState))
}

const subscribe = (listener) => {
    listeners.push(listener)
    return () => {
        listeners = listeners.filter(l => l !== listener)
    }
}


export const useDashboardLoader = () => {
    const [isLoading, setIsLoading] = useState(isLoadingState)

    useEffect(() => {
        const unsubscribe = subscribe(setIsLoading);
        return () => unsubscribe();
    }, []);

    return isLoading;
}

export const toggleLoader = (state) => setLoaderState(state)